<template>
  <div class="system-pageAddD" id="app" style="overflow-y: scroll;">
    <mt-header title="新建公文">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div style="width: 21rem; ">
      <div class="userinfoAdd">
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="userName" label="发起人" />
        </div>
        <van-field
            v-model="company"
            type="text"
            label="来文单位"
        />
        <van-field
            v-model="documentnum"
            type="text"
            label="文件原号"
        />
          <mt-cell label="收文日期" @click.native="selectLastRepairTime">
            <div style="font-size: 1.2rem;color: black;">{{ applyTime }}</div>
            <img
                style="width: 2rem; padding-right: 0.5rem"
                v-if="!applyTime"
                src="@/assets/icons/svg/dateChoose.svg"
            />
            <div class="mint-field-clear" v-else @click.stop="clearLastRepairTime">
              <i class="mintui mintui-field-error"></i>
            </div>
          </mt-cell>
        <van-field
            v-model="documentName"
            type="text"
            label="文件标题"
        />
<!--        <van-field-->
<!--            label="备注"-->
<!--            class="owntext"-->
<!--            v-model="documentDescribe"-->
<!--            rows="2"-->
<!--            autosize-->
<!--            type="textarea"-->
<!--            placeholder=""-->
<!--            show-word-limit-->
<!--        />-->
        <van-field name="uploader" label="附件">
          <template #input>
            <div  class="btn btn-default"style="position: relative; overflow: hidden;
              margin-top: 6px;">
              <i class="glyphicon glyphicon-open"></i> 上传附件
              <input type="file" name="filePath" style="opacity: 0; position: absolute;
               top: 12px; right: 0; " class='inpu' @change="fileListChange">
            </div>
          </template>
        </van-field>
        <van-field name="uploader" label="">
          <template #input>
            <div v-if="fileList.length!=0" style="display: flex; flex-direction: column;">
              <div
                  v-for="(item, idx) in fileList"
                  :key="idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item }}</span><div class="delete-btn" @click.prevent="fileListdel(item)">x</div>
              </div>
            </div>
          </template>
        </van-field>
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="nameuser" label="拟办人员" readonly/>
        </div>
        <div class="sub" @click.prevent="handelSubmit">提交</div>
      </div>
    </div>
    <!-- 收文时间选择 -->
    <van-calendar
        v-model="lastRepairTimeVisible"
        type="single"
        :min-date="minDate"
        @confirm="onLastRepairTimeConfirm"
    >
    </van-calendar>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      currentStartDate: new Date(),
      company: "",
      applyTime: "",
      documentnum: "",
      fileList: [],
      fileIds: [],
      documentName: "",
      // documentDescribe: "",
      userName: "",
      userId:"",
      nameuser: null,//审核人姓名
      lastRepairTimeVisible:false,
      userInfo:{}
    };
  },
  computed: {
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.userName = this.userInfo.userName
    this.userId = this.userInfo.userId
    this.applyTime =this.formatDate(new Date())
    await request({
      url: "getOfficeName",
      method: "get"
    }).then( response => {
      this.nameuser = response
    })
  },
  watch: {
  },
  methods: {
    // 清除时间
    clearLastRepairTime() {
      if (this.applyTime) {
        this.applyTime = '';
      }
    },
    selectLastRepairTime() {
      this.lastRepairTimeVisible = true;
    },
    onLastRepairTimeConfirm(value) {
      this.applyTime = this.formatDate(value);
      this.lastRepairTimeVisible = false
    },
    formatDate(timestamp) {
      // 创建一个新的Date对象，使用时间戳初始化
      const date = new Date(timestamp);

      // 获取各个时间组件
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      // 组合成所需的格式
      return `${year}-${month}-${day}`;
    },
    fileListChange(event){
      const file = event.target.files[0]
      this.fileList.push(file.name)
      axios({
        url: process.env.VUE_APP_SSO_URL+"appSaveDfile",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {file:file,userId:this.userId}
      }).then(  response => {
        this.fileIds.push(response.data.attachmentId)
      })
    },
    fileListdel(attachment){
      this.fileList.splice(this.fileList.indexOf(attachment),1)
    },
    reset(){
      this.documentName= "",
      // this.documentDescribe= "",
      this.userName= "",
      this.userId="",
      this.userInfo={}
    },
    async handelSubmit() {
      if (!this.company) {
        Toast({
          message: "请填写来文单位"
        });
        return;
      }
      if (!this.documentnum) {
        Toast({
          message: "请填写文件原号"
        });
        return;
      }
      if (!this.applyTime) {
        Toast({
          message: "请选择收文时间"
        });
        return;
      }
      if (!this.documentName) {
        Toast({
          message: "请填写文件标题"
        });
        return;
      }
      let params = {
        company: this.company,
        applyTime: this.applyTime,
        documentnum: this.documentnum,
        userId: this.userId,
        documentName: this.documentName,
        // documentDescribe: this.documentDescribe,
        nameuser: this.nameuser,
        fileIds:this.fileIds.join(',')
      };
      console.log(params)
      axios({
        url: process.env.VUE_APP_SSO_URL+"appaddDocument",
        method: "POST",
        data:params
      }).then(res => {
        Toast({
              message: "新增成功",
              position: 'middle',
              iconClass: "icon icon-success"
            });
        this.goBack();
      })
    },
    goBack() {
      this.$router.push("/home");
    }
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 10px;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}
.delete-btn {
  color: red;
  cursor: pointer;
  margin-left: 50px;
  /* 可以根据需要添加其他样式，比如字体大小、背景色等 */
}
.mint-cell-label {
  font-size: 1.2rem !important;
  font-weight: 700;
  color: #6d9eeb !important;
  margin-left: -20px;
}
body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}

.userinfoAdd {
  margin-left: 1rem /* 30/16 */;
  height: 20rem;
  line-height: 3rem;
  .van-field__control {
    line-height:  2rem;
    font-size: 1.5rem !important;
    margin-top: 10px;
  }
  .van-field__label {
    span{
      font-size: 1.2rem !important;
      font-weight: 700;
      color: #6d9eeb;
    }
    line-height:  2rem;
    font-size: 2rem !important;
    margin-top: -20px;
  }
  .van-field__value {
    line-height:  2rem;
    font-size: 2rem !important;
    margin-top: 10px;
  }
  .owntext {
    padding: 0 !important;

    .van-field__control {
      height: 1800px !important;
    }
    .van-field__word-limit {
      height: 75px;
      line-height: 75px;
      margin-bottom: 30px;
    }
  }
  .ownupload {
    margin: 0.5rem 0;
    .van-uploader__preview {
      margin: 10px 10px 10px 0;
      .van-image__error-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-image,
    .van-uploader__upload {
      width: 200px;
      height: 200px;
      border: 1px dashed #ccc;
      .van-uploader__upload-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-delete {
      width: 50px;
      height: 50px;
      .van-uploader__preview-delete-icon {
        font-size: 55px;
      }
    }
  }
  .van-cell {
    align-items: center;
    .van-field__label {
      width: 400px;
      font-size: 60px;
      height: 100px;
      line-height: 100px;
      color: #382c2c;
    }
  }
  .van-field__body {
    input {
      border: none !important;
      color: black;
    }
    textarea {
      padding-left: 30px;
    }
  }
  .nameusersub{
    width: 20%;
    height: 100px;
    line-height: 100px;
    font-size: 50px;
    background: #5cb85c;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
  }
  .sub {
    width: 100%;
    height: 200px;
    line-height: 200px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
}
.system-pageAddD {
  width: 22rem;
  height: 100vh;
  background-color: #fff;
  font-family: "PingFangSC-Regular";
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.van-field__error-message {
  line-height: 1.3rem;
}
.custom-list {
  overflow-y: auto; /* 如果内容超出容器高度，则启用垂直滚动 */
  padding: 0;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  background-color: #fff; /* 背景颜色 */
  border-radius: 4px; /* 圆角 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.list-item {
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #ebeef5; /* 分隔线 */
}
.list-item input:disabled {
  opacity: 0.5; /* 置灰效果 */
  cursor: not-allowed; /* 禁止点击的鼠标样式 */
}
.item-content{
  width: 21rem;
}
/* 为title定义样式，这通常是列表项中的主标题 */
.title {
  font-size: 1.213333rem; /* 字体大小 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 字体颜色 */
  margin-bottom: 8px; /* 与副标题之间的间距 */
}

/* 为subtitle定义样式，这通常是列表项中的副标题或额外信息 */
.subtitle {
  font-size: 1.213333rem; /* 字体大小 */
  color: #666; /* 字体颜色 */
}

/* 额外的样式，例如复选框 */
.list-item input[type="checkbox"] {
  margin-top: 0; /* 移除复选框上方的默认间距 */
  margin-right: 16px; /* 复选框与文本之间的间距 */
}
</style>
